"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextareaField = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const input_styles_1 = require("@/components/common/input/input.styles");
const textfield_helpers_1 = require("@/components/common/input/semantics/textfield.helpers");
require("@/components/common/input/textarea");
const utils_1 = require("@/utils");
let TextareaField = class TextareaField extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.value = '';
        this.name = '';
        this.placeholder = '';
        this.rows = 2;
        this.optional = false;
        this.disabled = false;
        this.ariaInvalid = null;
        this.inputId = (0, utils_1.uniqueId)('mm-textarea');
    }
    render() {
        return (0, lit_1.html) `
      ${(0, textfield_helpers_1.renderFieldLabel)(this.inputId, this.label, this.optional)}
      <mm-textarea
        input-id=${this.inputId}
        .value=${this.value}
        .name=${this.name}
        .placeholder=${this.placeholder}
        .rows=${this.rows}
        ?disabled=${this.disabled}
        aria-invalid=${(0, if_defined_js_1.ifDefined)(this.ariaInvalid ?? undefined)}
        aria-describedby=${this.description ? this.descriptionId : lit_1.nothing}
        @input=${this.handleTextareaInput}
      >
        <slot name="leading" slot="leading"></slot>
        <slot name="trailing" slot="trailing"></slot>
      </mm-textarea>
      ${(0, textfield_helpers_1.renderFieldDescription)(this.description, this.descriptionId)}
    `;
    }
    // 호스트는 포커스를 받지 않으므로 mm-textarea로 넘긴다.
    focus(options) {
        this.textarea?.focus(options);
    }
    get descriptionId() {
        return `${this.inputId}-description`;
    }
    handleTextareaInput(event) {
        this.value = event.detail.value;
    }
};
TextareaField.styles = input_styles_1.textfieldStyles;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TextareaField.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TextareaField.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TextareaField.prototype, "placeholder", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TextareaField.prototype, "label", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TextareaField.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], TextareaField.prototype, "rows", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], TextareaField.prototype, "optional", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], TextareaField.prototype, "disabled", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-invalid' })
], TextareaField.prototype, "ariaInvalid", void 0);
__decorate([
    (0, decorators_js_1.query)('mm-textarea')
], TextareaField.prototype, "textarea", void 0);
TextareaField = __decorate([
    (0, decorators_js_1.customElement)('mm-textarea-field')
], TextareaField);
exports.TextareaField = TextareaField;
//# sourceMappingURL=data:application/json;base64,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